module.exports = __webpack_public_path__ + "img/ico27.8f77b556.jpg";